import { render } from "./BidWorkspace.vue?vue&type=template&id=9ee76f96&scoped=true"
import script from "./BidWorkspace.vue?vue&type=script&lang=js"
export * from "./BidWorkspace.vue?vue&type=script&lang=js"

import "./BidWorkspace.vue?vue&type=style&index=0&id=9ee76f96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ee76f96"]])

export default __exports__